export const RESET = 'CATEGORY_LIST_RESET'
export const SET_ITEMS = 'CATEGORY_LIST_SET_ITEMS'
export const SET_ERROR = 'CATEGORY_LIST_SET_ERROR'
export const SET_VIEW = 'CATEGORY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CATEGORY_LIST_TOGGLE_LOADING'
